import { render, staticRenderFns } from "./ModalMotivo.vue?vue&type=template&id=484891d7&scoped=true"
import script from "./ModalMotivo.vue?vue&type=script&lang=js"
export * from "./ModalMotivo.vue?vue&type=script&lang=js"
import style0 from "./ModalMotivo.vue?vue&type=style&index=0&id=484891d7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "484891d7",
  null
  
)

export default component.exports